import type { Building } from "building-types/building/buildingTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { roomEntityHandleForSelectingReportingUnit } from "building-types/handles/roomEntityHandleForSelectingReportingUnit";
import { componentInstanceChainFromId } from "doc/entity/componentInstanceEntityResolve";

export function entityHandleForSelectingReportingUnitFromLevel(
  levelId: string,
  rooms: Building["rooms"],
  roomsByLevel: Building["roomsByLevel"],
): DocEntityHandle | undefined {
  const firstRoomId = roomsByLevel[levelId]?.[0];
  return firstRoomId ? roomEntityHandleForSelectingReportingUnit(rooms[firstRoomId]) : undefined;
}

/** Routes instance-scoped entity ids to the component instance chain root. */
export function entityHandleForSelectingReportingUnitFromEntityId(
  entityId: string,
  fallbackHandle: DocEntityHandle,
): DocEntityHandle {
  const chain = componentInstanceChainFromId(entityId);
  if (!chain?.length) {
    return fallbackHandle;
  }
  return { type: "COMPONENT_INSTANCE", id: chain[0] };
}
